// interface ApiString {
//   apiString: string;
// }

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"
import { useQuery } from "@tanstack/react-query"

async function showMe() {
  return fetch(
    `${import.meta.env.VITE_BASE_URL}/api/users/profile`,
    // +
    //   new URLSearchParams({
    //     sessionToken: sessionToken,
    //   })
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({
      //   sessionToken: sessionToken,
      // }),
    }
  ).then((data) => data.json())
}

export function useGetMe() {
  return useQuery({
    queryKey: queryKeys.users.me().queryKey,
    queryFn: () =>
      client.get(`/users/profile`).then((response) => response.data),
  })
}

export default showMe
